import { useCallback } from "react";
import { ScrollView, StyleSheet } from "react-native";

import { getPhoneCountryCode, useBrowser } from "@stepapp/core";
import { Block, Button, PhoneInput, Typography, useBreakpoints } from "@stepapp/ui";

import { useTranslation } from "react-i18next";
import { useAppLinks } from "../../src/hooks";
import { AppStorage } from "../../src/services/AppStorage";
import { useRegisterFormContext } from "./_layout";

export default function RegisterPhoneInputScreen() {
  const { fullHdHeight } = useBreakpoints();
  const { t } = useTranslation();
  const { PrivacyPolicy, TermsOfUse } = useAppLinks();

  const {
    formState: { errors },
    watch,
    setValue,
    trigger,
  } = useRegisterFormContext();

  const handleBlur = useCallback(() => trigger("phoneNumber"), [trigger]);

  const handleChange = useCallback(
    (value: string) => {
      setValue("phoneNumber", value, {
        shouldTouch: true,
        shouldValidate: true,
      });
    },
    [setValue],
  );

  const phoneNumber = watch("phoneNumber");
  const openPrivacyPolicy = useBrowser(PrivacyPolicy);
  const openTermsOfUse = useBrowser(TermsOfUse);

  return (
    <ScrollView>
      <Typography variant={fullHdHeight ? "largeTitle" : "title"}>
        {t("screens.phoneForm.title")}
      </Typography>

      <Block paddingVertical={fullHdHeight ? 4 : 2}>
        <Typography variant="paragraph" type="secondary">
          {t("pages.serviceSummary.SMSInfo")}
        </Typography>
      </Block>

      <PhoneInput
        error={errors?.phoneNumber?.message}
        label={t("common.phone")}
        mask="PhoneNumber"
        testID="phoneNumberInput"
        onBlur={handleBlur}
        onChangeText={handleChange}
        prefix={getPhoneCountryCode(AppStorage().get("countryCode"))}
        value={phoneNumber}
      />

      <Block alignCenter justifyCenter row style={styles.footer}>
        <Typography center variant="label">
          {t("screens.login.selectingOneOfAbove")}
        </Typography>

        <Block row>
          <Button
            label={t("screens.login.termsOfUse")}
            onPress={openTermsOfUse}
            type="smallInlineLink"
          />
          <Typography variant="label">{t("screens.login.and")}</Typography>
          <Button
            label={t("screens.login.privacyPolicy")}
            onPress={openPrivacyPolicy}
            type="smallInlineLink"
          />
        </Block>
      </Block>
    </ScrollView>
  );
}

const styles = StyleSheet.create({
  footer: {
    width: "100%",
    flexWrap: "wrap",
  },
});
